import { createAction, props } from '@ngrx/store';

export const loadAsymmetryVariableRanges = createAction(
  '[AsymmetryVariableRangesStore] Load AsymmetryVariableRangesStores'
);

export const loadAsymmetryVariableRangesSuccess = createAction(
  '[AsymmetryVariableRangesStore] Load AsymmetryVariableRangesStores Success',
  props<{ data: any }>()
);

export const loadAsymmetryVariableRangesFailure = createAction(
  '[AsymmetryVariableRangesStore] Load AsymmetryVariableRangesStores Failure',
  props<{ error: any }>()
);
